// external-tabs.js - Complete Script
(function() {
    'use strict';
    
    // Prevent multiple initializations
    if (window.tabsInitialized) {
        return;
    }
    
    // Configuration
    const CONFIG = {
        scrollThreshold: 100,
        fadeInDuration: 400,
        fadeOutDuration: 400,
        scrollOffset: 155,
        observerOffset: 165,
        debounceDelay: 150,
        retryDelay: 100,
        maxRetries: 50
    };
    
    let retryCount = 0;
    let scrollTimeout;
    let isInitialized = false;
    
    // Utility functions
    function log(message) {
        console.log('[Tabs Script]:', message);
    }
    
    function waitForElement(selector, callback, maxWait = 5000) {
        const element = document.querySelector(selector);
        if (element) {
            callback(element);
            return;
        }
        
        if (maxWait <= 0) {
            log(`Element ${selector} not found after waiting`);
            return;
        }
        
        setTimeout(() => waitForElement(selector, callback, maxWait - 100), 100);
    }
    
    // Animation functions
    function fadeIn(element, duration = CONFIG.fadeInDuration) {
        if (!element) return;
        
        element.style.opacity = '0';
        element.style.display = 'flex';
        element.style.transition = `opacity ${duration}ms ease-in-out`;
        
        requestAnimationFrame(() => {
            element.style.opacity = '1';
        });
    }
    
    function fadeOut(element, duration = CONFIG.fadeOutDuration) {
        if (!element) return;
        
        element.style.opacity = '1';
        element.style.transition = `opacity ${duration}ms ease-in-out`;
        element.style.opacity = '0';
        
        setTimeout(() => {
            if (element.style.opacity === '0') {
                element.style.display = 'none';
            }
        }, duration);
    }
    
    // Main functionality
    function toggleTabsVisibility() {
        const tabsDiv = document.querySelector('.tabs_pdp');
        if (!tabsDiv) return;
        
        const isVisible = tabsDiv.style.display !== 'none' && tabsDiv.style.display !== '';
        const shouldShow = window.scrollY > CONFIG.scrollThreshold;
        
        if (shouldShow && !isVisible) {
            fadeIn(tabsDiv);
        } else if (!shouldShow && isVisible) {
            fadeOut(tabsDiv);
        }
    }
    
    function handleTabClick(e) {
        const clickedTab = e.target.closest('.dev_adcts_click_tab_button');
        if (!clickedTab) return;
        
        e.preventDefault();
        
        const targetId = clickedTab.getAttribute('data-categories-title');
        const targetElement = document.getElementById(`dev_show_block-${targetId}`);
        
        if (targetElement) {
            const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
            
            if (targetId === "Images") {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            } else {
                window.scrollTo({
                    top: elementPosition - CONFIG.scrollOffset,
                    behavior: 'smooth'
                });
            }
        }
        
        // Update active states
        const allTabs = document.querySelectorAll('.dev_adcts_click_tab_button');
        allTabs.forEach(tab => tab.classList.remove('active'));
        clickedTab.classList.add('active');
        
        log(`Tab clicked: ${targetId}`);
    }
    
    function updateActiveClass() {
        if (window.scrollY <= CONFIG.scrollThreshold) {
            // Reset to first tab when at top
            const activeTabs = document.querySelectorAll('.dev_acts_tab_button.active');
            activeTabs.forEach(el => el.classList.remove('active'));
            
            const firstTabButton = document.querySelector('.dev_acts_tab_button');
            if (firstTabButton) {
                firstTabButton.classList.add('active');
                scrollTabIntoView(firstTabButton);
            }
            return;
        }
        
        const h3Tags = document.querySelectorAll(".dev_observer_active");
        
        h3Tags.forEach(tag => {
            const rect = tag.getBoundingClientRect();
            const tagDistanceFromTop = rect.top;
            
            if (tagDistanceFromTop <= CONFIG.observerOffset && tagDistanceFromTop >= 0) {
                const activeTabs = document.querySelectorAll('.dev_acts_tab_button.active');
                activeTabs.forEach(el => el.classList.remove('active'));
                
                const matchingTabs = document.querySelectorAll(`.${tag.id}`);
                matchingTabs.forEach(el => {
                    el.classList.add('active');
                    if (tag.id !== 'dev_show_block-Images') {
                        scrollTabIntoView(el);
                    }
                });
            }
        });
    }
    
    function scrollTabIntoView(element) {
        if (element && element.scrollIntoView) {
            element.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'nearest', 
                inline: 'center' 
            });
        }
    }
    
    function adjustHeaderPosition() {
        // Try multiple ways to find the header
        let header = null;
        
        if (window.currentSectionId) {
            header = document.getElementById(`shopify-section-${window.currentSectionId}`);
        }
        
        if (!header) {
            header = document.querySelector('[id^="shopify-section-"]');
        }
        
        if (!header) {
            // Fallback to section container
            header = document.querySelector('.npdp-scroll-tab-prnt');
        }
        
        if (!header) return;
        
        const windowWidth = window.innerWidth;
        
        if (windowWidth > 768) {
            header.style.top = "120px";
        } else if (windowWidth <= 768 && windowWidth > 430) {
            header.style.top = "70px";
        } else if (windowWidth <= 430 && windowWidth > 360) {
            header.style.top = "70px";
        } else if (windowWidth <= 360) {
            header.style.top = "65px";
        }
    }
    
    function setupJudgeMeReviews() {
        const targetElement = document.getElementById('shopify-block-judge_me_reviews_review_widget_jEDHzH');
        
        if (targetElement && !targetElement.parentElement.id.includes('dev_show_block-judge-me-reviews')) {
            const newParentDiv = document.createElement('div');
            newParentDiv.id = 'dev_show_block-judge-me-reviews';
            newParentDiv.className = 'dev_observer_active';
            
            // Insert the new div before the target element
            targetElement.parentNode.insertBefore(newParentDiv, targetElement);
            // Move the target element inside the new div
            newParentDiv.appendChild(targetElement);
            
            log('Judge.me reviews wrapped successfully');
        }
    }
    
    function attachEventListeners() {
        // Scroll event for tabs visibility
        window.addEventListener('scroll', function() {
            toggleTabsVisibility();
        });
        
        // Scroll event for active class updates (debounced)
        window.addEventListener('scroll', function() {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(updateActiveClass, CONFIG.debounceDelay);
        });
        
        // Click event for tabs
        document.addEventListener('click', handleTabClick);
        
        // Resize event for header position
        window.addEventListener('resize', adjustHeaderPosition);
        
        log('Event listeners attached');
    }
    
    function initializeTabs() {
        if (isInitialized) {
            log('Already initialized');
            return;
        }
        
        log('Attempting to initialize tabs...');
        
        // Check if required elements exist
        const tabsDiv = document.querySelector('.tabs_pdp');
        if (!tabsDiv) {
            retryCount++;
            if (retryCount < CONFIG.maxRetries) {
                log(`Tabs div not found, retrying... (${retryCount}/${CONFIG.maxRetries})`);
                setTimeout(initializeTabs, CONFIG.retryDelay);
                return;
            } else {
                log('Max retries reached. Initialization failed.');
                return;
            }
        }
        
        log('Tabs div found, proceeding with initialization');
        
        // Initially hide the tabs_pdp div
        tabsDiv.style.display = 'none';
        
        // Setup event listeners
        attachEventListeners();
        
        // Initial calls
        toggleTabsVisibility();
        adjustHeaderPosition();
        
        // Setup Judge.me reviews (with delay to ensure DOM is ready)
        setTimeout(setupJudgeMeReviews, 500);
        
        // Mark as initialized
        isInitialized = true;
        window.tabsInitialized = true;
        
        log('Tabs functionality initialized successfully');
    }
    
    // Public API
    window.TabsAPI = {
        init: initializeTabs,
        toggleVisibility: toggleTabsVisibility,
        updateActive: updateActiveClass,
        adjustHeader: adjustHeaderPosition
    };
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeTabs);
    } else {
        // DOM is already ready
        initializeTabs();
    }
    
    // Additional fallback initialization
    setTimeout(function() {
        if (!isInitialized) {
            log('Fallback initialization triggered');
            initializeTabs();
        }
    }, 1000);
    
    // Watch for dynamic content loading
    if (window.MutationObserver) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' && !isInitialized) {
                    const tabsDiv = document.querySelector('.tabs_pdp');
                    if (tabsDiv) {
                        log('Tabs detected via MutationObserver');
                        initializeTabs();
                        observer.disconnect();
                    }
                }
            });
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        
        // Disconnect observer after 10 seconds to prevent memory leaks
        setTimeout(() => observer.disconnect(), 10000);
    }
    
    log('Script loaded and ready');

})();